import React from 'react';
import './Banner.css';
import BannerDesc from './img/banner.jpg';
import BannerMob from './img/banner-mob.jpg';

const Banner = () => {
    return (
        <div className='Banner'>
            <img className='banner banner-desc' src={BannerDesc} alt="" />
            <img className='banner banner-mob' src={BannerMob} alt="" />
        </div>
    );
};

export default Banner;